import React from 'react';
import styled from '@emotion/styled';
import { ButtonV2 } from '@bbkAdminComponents/buttons';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';

type ButtonV2Props = React.ComponentProps<typeof ButtonV2>;
export const Done: React.FC<
  ButtonV2Props & { disabled?: boolean; label?: string }
> = ({
  onClick,
  disabled = false,
  label = 'Done',
  children,
  className,
  ...props
}) => (
  <ButtonV2
    primary
    onClick={onClick}
    disabled={disabled}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    {children ?? (
      <>
        {Icons.checkmark}
        <span className="tw-ml-2">{label}</span>
      </>
    )}
  </ButtonV2>
);

export const CloseOverlay: React.FC<ButtonV2Props> = ({
  onClick,
  className,
  ...props
}) => (
  <ButtonV2
    circle
    onClick={onClick}
    className={cs('tw-flex tw-items-center tw-justify-center', className)}
    {...props}
  >
    {Icons.closeProper}
  </ButtonV2>
);

export const Revert: React.FC<ButtonV2Props> = ({
  onClick,
  className,
  ...props
}) => (
  <ButtonV2
    onClick={onClick}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    <div className="tw-mb-[-2px] tw-mt-[-3px]">{Icons.resetArrow}</div>
    <span className="tw-ml-2">Revert</span>
  </ButtonV2>
);

export const CopyShareLink: React.FC<ButtonV2Props> = ({
  onClick,
  className,
  ...props
}) => (
  <ButtonV2
    onClick={onClick}
    className={cs('tw-[&_svg]:tw-h-[17px] tw-flex tw-items-center', className)}
    {...props}
  >
    {Icons.link}
    <span className="tw-ml-2">Copy share link</span>
  </ButtonV2>
);

export const Publish: React.FC<ButtonV2Props> = ({
  onClick,
  children,
  className,
  ...props
}) => (
  <ButtonV2
    success
    onClick={onClick}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    {children ?? (
      <>
        <div className="tw-mb-[-2px] tw-mt-[-3px]">{Icons.publish}</div>
        <span className="tw-ml-2">Publish</span>
      </>
    )}
  </ButtonV2>
);

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dddfe2;
  background: #fff;
  min-height: 60px;
  position: sticky;
  top: 0;
  z-index: 20;
`;
